

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
     $(".close_floatright").on("click", function (e) {
        e.stopPropagation(); // Ngăn event bubbling
        $(".floatright__main").toggleClass("active")
        $(".close_floatright").toggleClass("active")
    })
});
